export default "__VITE_ASSET__BcIc_bQ1__"